export enum TransactionStatus {
    NEW = "NEW", // Транзакция создана, но еще не обработана
    AUTHORIZED = "AUTHORIZED", // Транзакция авторизована (деньги зарезервированы)
    CONFIRMED = "CONFIRMED", // Транзакция подтверждена (деньги списаны)
    DECLINED = "DECLINED", // Транзакция отклонена
    REFUNDED = "REFUNDED", // Транзакция возвращена
    PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED", // Транзакция частично возвращена
    FAILED = "FAILED", // Транзакция не удалась
    CANCELLED = "CANCELLED", // Транзакция отменена
    REJECTED = "REJECTED" // Транзакция отклонена банком
}

export class TransactionStatusHelper {
    static isSuccess(status: string): boolean {
        return status === TransactionStatus.CONFIRMED || status === TransactionStatus.AUTHORIZED;
    }

    static isFailed(status: string): boolean {
        return status === TransactionStatus.DECLINED || 
               status === TransactionStatus.FAILED || 
               status === TransactionStatus.CANCELLED || 
               status === TransactionStatus.REJECTED;
    }

    static isPending(status: string): boolean {
        return status === TransactionStatus.NEW;
    }

    static getStatusText(status: string): string {
        switch (status) {
            case TransactionStatus.CONFIRMED:
                return "Подтверждено";
            case TransactionStatus.AUTHORIZED:
                return "Авторизовано";
            case TransactionStatus.DECLINED:
                return "Отклонено";
            case TransactionStatus.FAILED:
                return "Не удалось";
            case TransactionStatus.CANCELLED:
                return "Отменено";
            case TransactionStatus.REJECTED:
                return "Отклонено банком";
            case TransactionStatus.NEW:
                return "Ожидает обработки";
            default:
                return "Неизвестный статус";
        }
    }
}

